import React from 'react';

import { verifyConditional } from '../helper';
import DocumentsLocations from '../templates/components/documentsLocations';
import DocumentsStakeholders from '../templates/components/documentsStakeholders';

import Input from './input';

const RepeatableGroup = ({
  name = null,
  config = {},
  data = {},
  allData = {},
  linkingData = {},
  linkingForms = {},
  ajaxOptions = [],
  viewConfig = {},
}) => {
  const label = () => {
    function getLabel(label) {
      switch (typeof label) {
        case 'string':
          return label;
        case 'object':
          const labelKey = Object.keys(label).find(cond =>
            verifyConditional(cond, data, allData));
          return label[labelKey];
        default:
          return label;
      }
    }
    if (config.outputLabel) {
      return getLabel(config.outputLabel);
    }
    if (config.label) {
      return getLabel(config.label);
    }
    return getLabel(config.sectionLabel);
  }

  const getTableInputs = () => {
    const dataLinkKey = Object.keys(config.inputs)
      .find(key => config.inputs[key].dataLink);

    if (dataLinkKey) {
      const extra = Object.keys(config.inputs).reduce((e, key) => {
        if (key !== dataLinkKey) {
          e[key] = config.inputs[key];
        }
        return e;
      }, {});

      return <Input
        linkingData={linkingData}
        key={dataLinkKey}
        parent={name}
        name={dataLinkKey}
        config={config.inputs[dataLinkKey]}
        extraInputs={Object.keys(extra).length ? extra : null}
        data={data}
        allData={allData}
        linkingForms={linkingForms}
        cols={4}
        isRepeatable={true}
        ajaxOptions={ajaxOptions}>
      </Input>
    }
    return <Input
      linkingData={linkingData}
      parent={name}
      name={name}
      config={config.inputs}
      extraCols={config.extraInputCol || 4}
      data={data[name] || []}
      allData={allData}
      linkingForms={linkingForms}
      isRepeatable={true}
      ajaxOptions={ajaxOptions}>
    </Input>
  }

  if (config.template) {
    switch (config.template) {
      case 'DOCUMENTS_LOCATIONS':
        const data = (allData || {})[name] || [];
        return (
          <DocumentsLocations
            data={data}
            allData={(allData || {})}
            config={config}
            viewConfig={viewConfig}
            linkingData={linkingData}
          />
        );
      case 'DOCUMENTS_STAKEHOLDERS':
        const scp = (allData || {})[name] || [];
        return (
          <DocumentsStakeholders
            data={scp}
            config={config}
            viewConfig={viewConfig}
            linkingData={linkingData}
          />
        );
      default:
    }
  }

  return <div className="group repeatable">
    {label() ? (
      <div className="title">
        <h1>{label()}</h1>
      </div>
    ) : null}
    {getTableInputs()}
  </div>;
}

export default RepeatableGroup;
